<script setup>
import { ref } from 'vue'
import useApi from '../../Services/useApi'
import TreeItem from './TreeItem.vue'

const props = defineProps(['index'])
const { getClassifications } = useApi()
const classifications = ref(null)
const treeConfig = { nodeWidth: 120, nodeHeight: 80, levelHeight: 200 }

getClassifications().then(res=>{
    classifications.value = res.classifications
    console.log(res.classifications[props.index])
})


</script>

<template>
    <div>
        <div class="tree" v-if="classifications!=null">
            <div class="classification" :class="[{'principal':classifications[props.index]?.principal},classifications[props.index]?.type]" href="#">{{classifications[props.index]?.name}}</div>
            <TreeItem :item='classifications[props.index]' :level="0"></TreeItem>
        </div>
    </div>
</template>
<style lang="scss">
.tree{
    margin-top: 50px;
    text-align: center;
    .unactive{
        opacity: 0.4;
        filter: grayscale(1);
    }
    .more-classification{
        font-size:10px;
        color: lightgray;
        margin-bottom: 10px;
    }
    .classification-link{
        font-size:10px;
        color: rgb(25, 0, 255);
        margin-bottom: 2px;
    }
    .classification{
        width: fit-content;
        margin: auto;
        margin-top: 10px;
        cursor: pointer;
        font-size: 10px;
        min-width: 100px;
        @media (max-width: 768px) {
            font-size: 13px;
            min-width: 200px;
        }
        &.VITA{
            border-bottom: solid 2px #C65EEB;
        }
        &.DOMINIO{
            border-bottom: solid 2px #77C3FF;
        }
        &.REINO{
            border-bottom: solid 2px #77FFF9;
        }
        &.DIVISIÓN{
            border-bottom: solid 2px #77FFB6;
        }
        &.CLASE{
            border-bottom: solid 2px #7BFF77;
        }
        &.ORDEN{
            border-bottom: solid 2px #BEFF77;
        }
        &.FAMILIA{
            border-bottom: solid 2px #FFFD77;
        }
        &.GENERO{
            border-bottom: solid 2px #FFBA77;
        }
        &.ESPECIE{
            border-bottom: solid 2px #EBAE85;
        }
        &:hover{
            transform: scale(1.1);
        }
    }
    .classification.principal{
        border: solid 2px rgba(63, 63, 63, 0.2);
        padding: 5px 15px;
        border-radius: 50px;
        &.VITA{
            background-color: #C65EEB;
        }
        &.DOMINIO{
            background-color: #77C3FF;
        }
        &.REINO{
            background-color: #77FFF9;
        }
        &.DIVISIÓN{
            background-color: #77FFB6;
        }
        &.CLASE{
            background-color: #7BFF77;
        }
        &.ORDEN{
            background-color: #BEFF77;
        }
        &.FAMILIA{
            background-color: #FFFD77;
        }
        &.GENERO{
            background-color: #FFBA77;
        }
        &.ESPECIE{
            background-color: #EBAE85;
        }
    }
}
.levelcont{
    display: inline-block;
    vertical-align: top;
    position: relative;
    /* Using plain CSS */
    @media (max-width: 768px) {
        display: block;
        width: 100% !important;
    }
}
.desk-arrow{
    margin-top: -2px !important;
    @media (max-width: 768px) {
        display: none;
    }
}
.mob-arrow{
    display: none;
    margin-top: -1px !important;
    @media (max-width: 768px) {
        display: block;
    }
}
</style>